"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Menu = _interopRequireDefault(require("./Menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The MenuGroup model module.
 * @module model/MenuGroup
 * @version 0.2.0
 */
var MenuGroup = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MenuGroup</code>.
   * @alias module:model/MenuGroup
   */
  function MenuGroup() {
    _classCallCheck(this, MenuGroup);

    MenuGroup.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(MenuGroup, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>MenuGroup</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MenuGroup} obj Optional instance to populate.
     * @return {module:model/MenuGroup} The populated <code>MenuGroup</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MenuGroup();

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }

        if (data.hasOwnProperty('group_name')) {
          obj['group_name'] = _ApiClient["default"].convertToType(data['group_name'], 'String');
        }

        if (data.hasOwnProperty('group_description')) {
          obj['group_description'] = _ApiClient["default"].convertToType(data['group_description'], 'String');
        }

        if (data.hasOwnProperty('i18n_group_key')) {
          obj['i18n_group_key'] = _ApiClient["default"].convertToType(data['i18n_group_key'], 'String');
        }

        if (data.hasOwnProperty('i18n_description_key')) {
          obj['i18n_description_key'] = _ApiClient["default"].convertToType(data['i18n_description_key'], 'String');
        }

        if (data.hasOwnProperty('position')) {
          obj['position'] = _ApiClient["default"].convertToType(data['position'], 'Number');
        }

        if (data.hasOwnProperty('render_as_paragraph')) {
          obj['render_as_paragraph'] = _ApiClient["default"].convertToType(data['render_as_paragraph'], 'Boolean');
        }

        if (data.hasOwnProperty('menus')) {
          obj['menus'] = _ApiClient["default"].convertToType(data['menus'], [_Menu["default"]]);
        }
      }

      return obj;
    }
  }]);

  return MenuGroup;
}();
/**
 * @member {Number} id
 */


MenuGroup.prototype['id'] = undefined;
/**
 * @member {String} group_name
 */

MenuGroup.prototype['group_name'] = undefined;
/**
 * @member {String} group_description
 */

MenuGroup.prototype['group_description'] = undefined;
/**
 * @member {String} i18n_group_key
 */

MenuGroup.prototype['i18n_group_key'] = undefined;
/**
 * @member {String} i18n_description_key
 */

MenuGroup.prototype['i18n_description_key'] = undefined;
/**
 * @member {Number} position
 */

MenuGroup.prototype['position'] = undefined;
/**
 * @member {Boolean} render_as_paragraph
 */

MenuGroup.prototype['render_as_paragraph'] = undefined;
/**
 * @member {Array.<module:model/Menu>} menus
 */

MenuGroup.prototype['menus'] = undefined;
var _default = MenuGroup;
exports["default"] = _default;